var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 5.03242 19.3129 4.22532 18.4 4.04001V12C18.4 12.7203 17.6615 13.2044 17.001 12.9169L14.7205 11.9246L12.3931 12.9195C11.7333 13.2015 11 12.7175 11 12V4ZM6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2ZM11.1 15.5C11.6523 15.5 12.1 15.9477 12.1 16.5C12.1 17.0523 11.6523 17.5 11.1 17.5H6.6C6.04772 17.5 5.6 17.0523 5.6 16.5C5.6 15.9477 6.04772 15.5 6.6 15.5H11.1ZM8.4 11.9C8.95228 11.9 9.4 12.3477 9.4 12.9C9.4 13.4523 8.95228 13.9 8.4 13.9H6.6C6.04772 13.9 5.6 13.4523 5.6 12.9C5.6 12.3477 6.04772 11.9 6.6 11.9H8.4ZM13 4V10.485L14.3309 9.91605C14.584 9.80785 14.8706 9.80877 15.123 9.91861L16.4 10.4743V4H13Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.bed7fe5af2f27a2c461549c0c8f6b439.svg";
export { ForwardRef as ReactComponent };